import React, { useState, useEffect } from 'react';
import { Calendar, ChevronDown } from 'lucide-react';
import { useAdmin } from '../../contexts/AdminContext';
import './TimeRangeSelector.css';

const FirebaseTimeRangeSelector = () => {
  const { dateRange, setDateRange } = useAdmin();
  const [showDropdown, setShowDropdown] = useState(false);

  const presets = [
    { label: 'Today', value: 'today', startDate: 'today', endDate: 'today' },
    { label: 'Yesterday', value: 'yesterday', startDate: 'yesterday', endDate: 'yesterday' },
    { label: 'Last 7 days', value: '7d', startDate: '7daysAgo', endDate: 'today' },
    { label: 'Last 30 days', value: '30d', startDate: '30daysAgo', endDate: 'today' },
    { label: 'This month', value: 'thisMonth', startDate: 'thisMonthStart', endDate: 'today' },
    { label: 'Last month', value: 'lastMonth', startDate: 'lastMonthStart', endDate: 'thisMonthStart' },
    { label: 'Last 90 days', value: '90d', startDate: '90daysAgo', endDate: 'today' },
    { label: 'This year', value: 'thisYear', startDate: 'thisYearStart', endDate: 'today' }
  ];

  const handlePresetSelect = (preset) => {
    setDateRange({
      startDate: preset.startDate,
      endDate: preset.endDate
    });
    setShowDropdown(false);
  };

  const getCurrentPresetLabel = () => {
    // Find which preset matches the current dateRange
    const preset = presets.find(
      p => p.startDate === dateRange.startDate && p.endDate === dateRange.endDate
    );
    return preset ? preset.label : 'Custom range';
  };

  const getActivePreset = () => {
    const preset = presets.find(
      p => p.startDate === dateRange.startDate && p.endDate === dateRange.endDate
    );
    return preset ? preset.value : null;
  };

  return (
    <div className="time-range-selector">
      <div className="time-range-main">
        <Calendar size={20} />

        <div className="time-range-dropdown">
          <button
            className="time-range-button"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <span>{getCurrentPresetLabel()}</span>
            <ChevronDown size={16} />
          </button>

          {showDropdown && (
            <>
              <div
                className="dropdown-backdrop"
                onClick={() => setShowDropdown(false)}
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 99
                }}
              />
              <div className="time-range-menu">
                {presets.map(preset => (
                  <button
                    key={preset.value}
                    className={`time-range-option ${getActivePreset() === preset.value ? 'active' : ''}`}
                    onClick={() => handlePresetSelect(preset)}
                  >
                    {preset.label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FirebaseTimeRangeSelector;
